// src/chatbot/components/MessageAvatar.tsx
import React from "react";
import { FaUser } from "react-icons/fa";
import type { Branch } from "~/types/new_types";

interface MessageAvatarProps {
  isUser: boolean;
  theme: Branch["theme"];
}

const MessageAvatar: React.FC<MessageAvatarProps> = ({ isUser, theme }) => {
  if (isUser) {
    return (
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
        style={{
          backgroundColor: `${theme.primaryColor}15`,
          color: theme.primaryColor,
        }}
      >
        <FaUser size={14} />
      </div>
    );
  }

  return (
    <div
      className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
      style={{
        backgroundColor: `${theme.primaryColor}15`,
        color: theme.primaryColor,
      }}
    >
      <img src="/test-envato-labs-image-edit_5.webp" alt="Robot ai Logo" />
    </div>
  );
};

export default MessageAvatar;
